import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-950">Página não encontrada</h1>
        <p className="mt-2 text-base text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-600">Volte para a página inicial e continue navegando</p>
        <a
          href="/"
          className="inline-flex items-center gap-2 mt-6 bg-accent-500 text-white font-semibold px-6 py-3 rounded-full text-sm hover:bg-accent-600 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          Voltar ao Início
        </a>
      </div>
    </div>
  );
}